import { createSlice } from "@reduxjs/toolkit";
import { DeliveryState } from ".";

const initialState: DeliveryState = {
  availableCars: [],
  bookings: [],
  booking: null,
  loading: false,
  car: null,
  extra: null,
  insurance: [],
  // NEW: Initialize booking selection
  bookingSelection: null,
  unavailableCars:[]
};

export const deliverySlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    
   
    setAvailableCars: (state, action) => {
      state.availableCars = action.payload;
    },
    setUnavailableCars:(state, action)=>{
      state.unavailableCars = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCar: (state, action) => {
      state.car = action.payload;
    },
    setExtra: (state, action) => {
      state.extra = action.payload;
    },
    setInsurance: (state, action) => {
      state.insurance = action.payload;
    },
    setBookings: (state, action) => {
      state.bookings = action.payload;
    },
    setBooking: (state, action) => {
      state.booking = action.payload;
    },
    clearExtras: (state) => {
      state.extra = [];
    },
    clearCarData: (state) => {
      state.car = null;
      state.extra = [];
      state.insurance = [];
      state.bookingSelection = null; // Also clear booking
    },
    // NEW: Set booking selection with all selected items
    setBookingSelection: (state, action) => {
      state.bookingSelection = action.payload;
    },
    // NEW: Update specific booking fields
    updateBookingSelection: (state, action) => {
      if (state.bookingSelection) {
        state.bookingSelection = {
          ...state.bookingSelection,
          ...action.payload,
        };
      }
    },
    // NEW: Clear booking selection
    clearBookingSelection: (state) => {
      state.bookingSelection = null;
    },
  },
});

const deliveryReducer = deliverySlice.reducer;
export const deliveryActions = deliverySlice.actions;
export default deliveryReducer;
